$(document).ready(function() {

  // Make elements clickable with data-href attribute
  $('[data-href]').on('click', function(e) {
    if (e.ctrlKey || e.metaKey) {
      window.open($(this).data('href'), '_blank')
      e.preventDefault()
    } else {
      self.location.href = $(this).data('href')
    }
  })
})
